<template>
  <div class="instruct-wrapper">
    <div class="instuctor-process-options">
      <WidgetToolbar title="Manager" :icon="require('@/assets/admin-icon/menu/instructor_active.svg')">
        <div class="options row">
          <widgetSearch placeholder="Search here..." icon="right" v-model="filter_form.query" @keyup="searchStudent">
          </widgetSearch>
          <div class="h-spacer"></div>
          <classDropdown :school="$getLoggedUser().company_name" @onSubmit="getSelectedClass">
            <span class="selected-class" v-if="!filter_form.class">
              All Departments
            </span>
            <span class="selected-class" v-else>{{
              filter_form.class.data.name
            }}</span>
          </classDropdown>
          <div class="v-line-divider" style="height: 40px"></div>
          <div class="filter-select-widget">
            <filter-select @onSubmit="sortSchoolStudent" v-model="filter_form.sort_by" :content="view_filter">
              <div class="filter-selected-label">
                <span v-if="filter_form.sort_by == 'all'">All Consultants</span>
                <span v-if="filter_form.sort_by == 'not_invited'">Not Invited Consultants</span>
                <span v-if="filter_form.sort_by == 'invited'">Invited Consultants</span>
                <span v-if="filter_form.sort_by == 'has_company'">Has Company</span>
                <span v-if="filter_form.sort_by == 'approved'">Approved Consultants</span>
              </div>
            </filter-select>
          </div>
          <div class="h-spacer" v-if="show_selected_student_options"></div>
          <widgetButton v-if="show_selected_student_options" @click="inviteSelectedStudent()" class="btn-secondary">
            Invite
          </widgetButton>
          <div v-if="show_selected_student_options" class="h-spacer"></div>
          <widgetButton v-if="show_selected_student_options" @click="approveSelectedStudent()" class="btn-primary">
            Approve
          </widgetButton>
          <div class="v-line-divider" style="height: 40px"></div>
          <div class="table-options">
            <SchoolNotifiation></SchoolNotifiation>
          </div>
          <dropdown-menu v-if="show_selected_student_options" class="table-menu">
            <ul>
              <li>
                <a @click.prevent="remindSelectedStudent()">Remind</a>
              </li>
              <li>
                <app-dialog title="Delete Consultant" ask="Are you sure you want to delete selected consultant?"
                  yesText="Yes" noText="No" @onComfirm="deleteSelectedStudent()">
                  <a>Delete</a>
                </app-dialog>
              </li>
              <li>
                <a @click.prevent="exportSelectedStudent()">Export</a>
              </li>
            </ul>
          </dropdown-menu>
        </div>
      </WidgetToolbar>
    </div>
    <div class="instruct-widget">
      <instructorProcessMenus></instructorProcessMenus>
      <div class="instruct-list">
        <div class="instruct-body" @scroll="onPageScoll"
          v-if="student_data && student_data.data.length > 0 && !isLoading">
          <!-- Data preview -->
          <table class="table-data">
            <thead class="table-header">
              <tr class="stack-title">
                <th class="stick-title">
                  <div class="force-start">
                    <input @change="checkAllStudent" v-model="isAllStudentSelected" type="checkbox" />
                    Name
                  </div>
                </th>
                <th class="stick-title">Email</th>
                <th class="stick-title">Invitation</th>
                <th class="stick-title">Profile completion</th>
                <th class="stick-title">CV/Resume</th>
                <th class="stick-title">Profile Approval</th>
                <th class="stick-title" width="90">More actions</th>
              </tr>
            </thead>
            <tbody class="table-body">
              <template>
                <tr v-for="(item, index) in student_data.data" :key="index" class="row-data">
                  <td>
                    <div class="profile-content">
                      <input @change="checkStudent" v-model="item.checked" class="checkbox" type="checkbox" />

                      <widgetProfile :title="item.first_name + ' ' + item.last_name"
                        :subtitle="item.profile ? item.profile.address : ''" :file_name="item.profile_picture"
                        :path="$fullUrl('images/profiles/')"></widgetProfile>
                    </div>
                  </td>
                  <td class="email">{{ item.email }}</td>
                  <td>
                    <widgetButton v-if="!item.invite_received && !item.invite_sent" @click="sendInvitation(item)"
                      class="btn-secondary">
                      Invite
                    </widgetButton>

                    <widgetBadget v-if="!item.invite_received && item.invite_sent" class="badge-secondary" text="Sent">
                    </widgetBadget>

                    <widgetBadget v-if="item.invite_received && item.invite_sent" class="badge-primary" text="Received">
                      <img class="icon" src="@/assets/icons/confirm_green.svg" />
                    </widgetBadget>
                  </td>
                  <td>
                    <div class="progress-widget" @click="viewFullProfile(item)">
                      <progressBar v-if="item.profile" :style="{ width: '110px' }" :class="{
                        'p-danger': item.profile.completion < 35,
                        'p-warning':
                          item.profile.completion < 65 &&
                          item.profile.completion >= 35,
                        'p-success': item.profile.completion >= 65,
                      }" :showNumber="true" numberPosition="left" v-model="item.profile.completion">
                      </progressBar>
                    </div>
                  </td>
                  <td>
                    <button class="btn-show-cv" v-if="item.cvs && item.cvs.length > 0" @click="showStudentCvs(item)">
                      <img src="@/assets/icons/attach-file-gray.svg" />
                      Resume
                    </button>
                  </td>
                  <td>
                    <app-dialog v-if="!item.completed &&
                      item.invite_received &&
                      item.invite_sent
                      " title="Approve Consultant" ask="Are you sure you want to approve this consultant?"
                      yesText="Yes" noText="No" yesBtnClass="approve-widget" @onComfirm="approveStudent(item)">
                      <widgetButton class="btn-primary"> Approve </widgetButton>
                    </app-dialog>

                    <widgetBadget v-if="item.completed" class="badge-primary" text="Approved">
                      <img class="icon" src="@/assets/icons/confirm_green.svg" />
                    </widgetBadget>
                  </td>
                  <td>
                    <div class="center">
                      <dropdown-menu class="table-menu">
                        <ul>
                          <li>
                            <a href @click.prevent="assignPrivateLia(item)">Assign to...</a>
                          </li>
                          <li v-if="item.invite_received && item.invite_sent">
                            <a @click.prevent="viewProfile(item)">View Profile</a>
                          </li>
                          <li>
                            <a @click="sendInvitation(item)"> Resend Invite </a>
                          </li>
                          <li v-if="item.invite_received && item.invite_sent">
                            <a @click.prevent="sendMessage(item)">Send Message</a>
                          </li>
                          <li v-if="item.invite_received && item.invite_sent">
                            <a @click.prevent="sendRemainder(item)">Send Reminder</a>
                          </li>
                          <li>
                            <app-dialog title="Delete Consultant" ask="Are you sure you want to delete this consultant?"
                              yesText="Delete" noText="Cancel" @onComfirm="deleteStudent(item)">
                              <a>Delete Consultant</a>
                            </app-dialog>
                          </li>
                        </ul>
                      </dropdown-menu>
                    </div>
                  </td>
                </tr>
              </template>
            </tbody>
          </table>
          <!-- loading on pagination -->
          <div class="loading-paginated-items" v-if="isLoadingDataOnPagination">
            <loading :height="15" color="#1ba5a4" :opacity="1" :width="15" :active.sync="isLoadingDataOnPagination"
              :is-full-page="false" :can-cancel="false" background-color="#fff" class="loader"></loading>
          </div>
        </div>
        <!-- Loading preview -->
        <div class="loading-widget" v-if="isLoading">
          <loading :height="40" :width="40" :active="true" color="#1ba5a4" background-color="#fff"
            :is-full-page="false" />
        </div>
        <div v-if="student_data && student_data.data.length == 0 && !isLoading" class="student-not-found-widget">
          <widgetNotFoundWidget title="No Consultants Found"
            content="Looks like you haven’t added any consultants yet, you can add consultants using the button below"
            btntext="Add new consultant" @click="() => {
              $router.push({
                name: 'organization',
                params: { type: 'students' },
              });
            }
              ">
            <img class="widget-img" src="@/assets/admin-icon/add-student-icon.svg" />
          </widgetNotFoundWidget>
        </div>
      </div>
    </div>

    <!-- Reminder modal -->
    <remainderModal v-if="show_remainder" :user="user_to_remaind" :type="remind_type" phase="phase_1"
      @close="closeRemainder">
    </remainderModal>

    <!-- Assign Lia To Consultant -->
    <AssignLiaModal v-if="show_assign_lia_modal" :student="selected_student" @close="show_assign_lia_modal = false"
      @success="show_assign_lia_modal = false"></AssignLiaModal>
  </div>
</template>

<script>
import { eventBus } from "@/main";
import instructorProcessMenus from "./widgets/instructorProcessMenus.vue";
import remainderModal from "../components/modals/remainderModal.vue";
import AssignLiaModal from "../../Instructor/components/modals/assignLiaModal.vue";
export default {
  name: "",
  components: {
    instructorProcessMenus,
    remainderModal,
    AssignLiaModal,
  },
  props: {},
  data: () => {
    return {
      selected_student: null,
      show_assign_lia_modal: false,
      invitation_chart: {
        series: [20, 80],
        colors: ["#1BA5A4", "#0884AF"],
        chart: {
          toolbar: {
            show: false,
            tools: {
              download: false,
              selection: false,
              zoom: false,
              zoomin: false,
              zoomout: false,
              pan: false,
            },
          },
        },
        dataLabels: {
          enabled: true,
          formatter: function (val, opts) {
            return parseInt(val) + "%";
          },
          textAnchor: "middle",
          dropShadow: {
            enabled: false,
          },
        },
        labels: ["", ""],
        tooltip: {
          enabled: false,
        },
        legend: {
          show: false,
        },
        stroke: {
          show: false,
        },
      },
      view_filter: [
        {
          value: "all",
          name: "All Consultants",
        },
        {
          value: "not_invited",
          name: "Not Invited",
        },
        {
          value: "invited",
          name: "Invited",
        },
        {
          value: "has_company",
          name: "Has Company",
        },
        {
          value: "approved",
          name: "Approved Consultants",
        },
      ],
      student_data: null,
      filter_form: {
        id: null,
        id_type: "",
        sort_by: "all",
        query: "",
        class: null,
        url_type: "",
        next_page_url: "",
      },
      show_remainder: false,
      user_to_remaind: null,
      remind_type: "student",
      report_data: {},
      show_selected_student_options: false,
      isLoading: false,
      isAllStudentSelected: false,
      isLoadingDataOnPagination: false,
    };
  },
  mounted() {
    let vm = this;
    vm.getAllStudent();
  },
  computed: {},
  watch: {},
  methods: {
    assignPrivateLia(item) {
      let vm = this;
      if (item.matched) {
        eventBus.$emit("openDialogMessage", {
          title: "Warning",
          message:
            "This consultant has already been matched with a Assignment. Are you sure you want to continue assign a new Assignment?",
          action_label: "Continue",
          callback: () => {
            vm.selected_student = item;
            vm.show_assign_lia_modal = true;
          },
          action_close_label: "Cancel",
        });
      } else {
        vm.selected_student = item;
        vm.show_assign_lia_modal = true;
      }
    },
    // =============================
    onPageScoll({ target }) {
      let vm = this;
      if (target.scrollTop + target.clientHeight >= target.scrollHeight - 100) {
        if (
          !vm.isLoadingDataOnPagination &&
          vm.student_data.current_page < vm.student_data.last_page
        ) {
          vm.getAllStudent("next");
        }
      }
    },
    searchStudent() {
      let vm = this;
      vm.isAllStudentSelected = false;
      vm.getAllStudent();
    },
    sortSchoolStudent() {
      let vm = this;
      vm.isAllStudentSelected = false;
      vm.getAllStudent();
    },
    getSelectedClass(item) {
      let vm = this;
      vm.isAllStudentSelected = false;
      if (item.type == "school") {
        vm.filter_form.class = null;
        vm.filter_form.id = null;
        vm.filter_form.id_type = item.type;
        vm.getAllStudent();
      } else {
        vm.filter_form.class = item;
        vm.filter_form.id = item.data.id;
        vm.filter_form.id_type = item.type;
        vm.getAllStudent();
      }
    },
    getAllStudent(type = "init") {
      let vm = this;
      if (type == "init") {
        vm.isLoading = true;
      }
      vm.isLoadingDataOnPagination = true;
      vm.filter_form.url_type = type;
      vm.filter_form.next_page_url = vm.student_data
        ? vm.student_data.next_page_url
        : "";
      vm.$store
        .dispatch("GET_ALL_SCHOOL_STUDENT", vm.filter_form)
        .then((responce) => {
          vm.isLoadingDataOnPagination = false;
          vm.isLoading = false;
          responce.data.data = responce.data.data.map((item) => {
            if (vm.isAllStudentSelected) {
              eventBus.$set(item, "checked", true);
            } else {
              eventBus.$set(item, "checked", false);
            }
            return item;
          });
          if (type == "init") {
            vm.student_data = responce.data;
            if (vm.student_data.current_page < vm.student_data.last_page) {
              vm.getAllStudent("next");
            }
          } else {
            vm.student_data.next_page_url = responce.data.next_page_url;
            vm.student_data.current_page = responce.data.current_page;
            vm.student_data.last_page = responce.data.last_page;
            responce.data.data.forEach((item) => {
              vm.student_data.data.push(item);
            });
          }
          vm.validateCheckedStudent();
        })
        .catch((error) => {
          vm.isLoadingDataOnPagination = false;
          vm.isLoading = false;
        });
    },
    validateCheckedStudent(type = "validate") {
      let vm = this;
      if (type == "validate") {
        vm.show_selected_student_options =
          vm.student_data.data
            .map((item) => item.checked)
            .filter((item) => item == true).length > 0;
        return;
      }
      return vm.student_data.data
        .filter((item) => item.checked == true)
        .map((item) => item.id);
    },
    checkAllStudent({ target }) {
      let vm = this;
      vm.isAllStudentSelected = target.checked;
      if (target.checked) {
        vm.student_data.data = vm.student_data.data.map((item) => {
          eventBus.$set(item, "checked", true);
          return item;
        });
      } else {
        vm.student_data.data = vm.student_data.data.map((item) => {
          eventBus.$set(item, "checked", false);
          return item;
        });
      }
      vm.validateCheckedStudent();
    },
    checkStudent() {
      let vm = this;
      vm.isAllStudentSelected = false;
      vm.validateCheckedStudent();
    },
    // =============================
    inviteSelectedStudent() {
      let vm = this;
      let payload = {
        ids: vm.validateCheckedStudent("ids"),
        isAllStudentSelected: vm.isAllStudentSelected,
        filter: vm.filter_form,
      };
      vm.$store
        .dispatch("INSTRUCTOR_SCHOOL_STUDENT_INVITE_SELECTED_PHASE1", payload)
        .then((responce) => {
          eventBus.$emit("openDialogMessage", {
            title: "Invitation successfully sent",
            message:
              "A notification has been sent to all selected consultant, we will notify you once they starts building there profile to be approved later.",
            action_label: "",
            action_path: "",
            action_close_label: "Close",
          });
          vm.getAllStudent();
          vm.$notify({
            group: "status",
            type: "success",
            title: "Mesage",
            text: "Invitation sent",
          });
        })
        .catch((error) => {
          vm.$notify({
            group: "status",
            type: "warn",
            title: "Warning",
            text: "Invitation not sent",
          });
        });
    },
    approveSelectedStudent() {
      let vm = this;
      let payload = {
        ids: vm.validateCheckedStudent("ids"),
        isAllStudentSelected: vm.isAllStudentSelected,
        filter: vm.filter_form,
      };
      vm.$store
        .dispatch("INSTRUCTOR_SCHOOL_STUDENT_APPROVE_SELECTED_PHASE1", payload)
        .then((responce) => {
          vm.getAllStudent();
          vm.$notify({
            group: "status",
            type: "success",
            title: "Mesage",
            text: "Selected consultant have been approved",
          });
        })
        .catch((error) => {
          vm.$notify({
            group: "status",
            type: "warn",
            title: "Warning",
            text: "Something went wrong, Try again",
          });
        });
    },
    deleteSelectedStudent() {
      let vm = this;
      let payload = {
        ids: vm.validateCheckedStudent("ids"),
        isAllStudentSelected: vm.isAllStudentSelected,
        filter: vm.filter_form,
      };
      vm.$store
        .dispatch("INSTRUCTOR_SCHOOL_STUDENT_DELETE_SELECTED_PHASE1", payload)
        .then((responce) => {
          vm.getAllStudent();
          vm.$notify({
            group: "status",
            type: "success",
            title: "Mesage",
            text: "Selected consultant have been deleted",
          });
        })
        .catch((error) => {
          vm.$notify({
            group: "status",
            type: "warn",
            title: "Warning",
            text: "Something went wrong, Try again",
          });
        });
    },
    exportSelectedStudent() {
      let vm = this;
      let payload = {
        ids: vm.validateCheckedStudent("ids"),
        isAllStudentSelected: vm.isAllStudentSelected,
        filter: vm.filter_form,
      };
      vm.$store
        .dispatch("INSTRUCTOR_SCHOOL_STUDENT_EXPORT_SELECTED_PHASE1", payload)
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", Date.now() + "_student.xlsx");
          document.body.appendChild(link);
          link.click();
        })
        .catch((error) => {
          vm.$notify({
            group: "status",
            type: "warn",
            title: "Warning",
            text: "Something went wrong, Try again",
          });
        });
    },
    remindSelectedStudent() {
      let vm = this;
      vm.user_to_remaind = vm.validateCheckedStudent("ids");
      vm.remind_type = "checked";
      vm.show_remainder = true;
    },
    // =========================
    sendInvitation(item) {
      let vm = this;
      vm.$store
        .dispatch("INVITE_SCHOOL_STUDENT", { copy_id: item.copy })
        .then((responce) => {
          eventBus.$emit("openDialogMessage", {
            title: "Invitation successfully sent",
            message:
              "A notification has been sent to <span style='color: #000;font-size: 16px;'>" +
              item.first_name +
              " " +
              item.last_name +
              "</span>, we will notify you once he starts building his profile to be approved later.",
            action_label: "",
            action_path: "",
            action_close_label: "Close",
          });
          vm.getAllStudent();
          vm.$notify({
            group: "status",
            type: "success",
            title: "Mesage",
            text: "Invite sent",
          });
        })
        .catch((error) => {
          vm.$notify({
            group: "status",
            type: "warn",
            title: "Warning",
            text: "Invitation not sent",
          });
        });
    },
    deleteStudent(item) {
      let vm = this;
      vm.$store
        .dispatch("INSTRUCTOR_DELETE_SCHOOL_STUDENT", {
          student_id: item.id,
        })
        .then((responce) => {
          vm.getAllStudent();
          vm.$notify({
            group: "status",
            title: "Success",
            text: "Consultant is now deleted",
            type: "success",
            duration: 3000,
          });
        })
        .catch((error) => {
          vm.$notify({
            group: "status",
            title: "Success",
            text: "Something went wrong, try again",
            type: "warn",
            duration: 3000,
          });
        });
    },
    sendRemainder(item) {
      let vm = this;
      vm.user_to_remaind = item;
      vm.remind_type = "student";
      vm.show_remainder = true;
    },
    approveStudent(item) {
      let vm = this;
      vm.$store
        .dispatch("INSTRUCTOR_APPROVE_SCHOOL_STUDENT", {
          student_id: item.id,
        })
        .then((responce) => {
          vm.getAllStudent();
          vm.$notify({
            group: "status",
            title: "Success",
            text: "Consultant profile is now approved",
            type: "success",
            duration: 3000,
          });
        })
        .catch((error) => {
          vm.$notify({
            group: "status",
            title: "Success",
            text: "Something went wrong, try again",
            type: "warn",
            duration: 3000,
          });
        });
    },
    sendMessage(item) {
      window.parent.postMessage({ message: "sendMessage", value: item }, "*");
    },
    viewFullProfile(item) {
      let vm = this;
      window.parent.postMessage(
        {
          message: "routeNow",
          value: {
            path: `/user/profile/${item.id}/public-information`,
            query: {
              allow: true,
            },
          },
        },
        "*"
      );
    },
    viewProfile(item) {
      let item_id = window.btoa(item.id);
      let name =
        item.first_name.toLowerCase().replace(/\s/g, "-") +
        "-" +
        item.last_name.toLowerCase().replace(/\s/g, "-") +
        "-" +
        item_id;
      window.parent.postMessage(
        {
          message: "routeNow",
          value: {
            name: "consultant-public-profile",
            params: { name: name },
          },
        },
        "*"
      );
    },
    showStudentCvs(item) {
      let vm = this;
      window.parent.postMessage(
        {
          message: "parentNewTabNavigate",
          value: `/crm?path=/cv/editor?user=${item.id}`,
        },
        "*"
      );
    },
    remindAll(value) {
      let vm = this;
      vm.remind_type = value;
      vm.show_remainder = true;
    },
    closeRemainder() {
      let vm = this;
      vm.show_remainder = false;
    },
  },
};
</script>
<style lang="scss" scoped>
$assets: "~@/assets";

.instruct-wrapper {
  width: 100%;
  height: calc(100% - 0px);
  display: flex;
  flex-direction: column;

  .instuctor-process-options {
    position: absolute;
    top: 10px;
    right: 10px;
    left: 10px;
  }

  .instruct-widget {
    height: 100%;
    position: relative;

    .custom-resizer {
      height: 100%;
    }

    .instruct-list {
      display: flex;
      flex-direction: column;
      min-width: calc(100% - 300px);
      height: calc(100% - 57px);
      width: 100%;
      position: relative;

      .loading-widget {
        background: #fff;
        padding: 10px 10px;
        height: 100%;
        position: relative;
        border-radius: 10px;
        overflow: hidden;
      }

      .student-not-found-widget {
        background: #fff;
        padding: 10px 10px;
        height: 100%;
        position: relative;
        border-radius: 10px;
        overflow: hidden;
        display: flex;

        .notfound-wrapper {
          width: 100%;

          .notfound-widget {
            width: 500px;
          }
        }
      }

      .instruct-body {
        background: #fff;
        height: 100%;
        overflow-y: auto;
        padding-bottom: 60px;
        border-radius: 5px;
        padding: 10px;

        .table-data {
          border-collapse: collapse;
          border-spacing: 0;
          width: 100%;

          tr {
            &.row-data {
              background: #fff;
            }

            &:hover {
              background: rgb(248, 248, 248);
              cursor: pointer;
            }

            th {
              &.stick-title {
                position: sticky;
                top: 0px;
                z-index: 999;
              }

              &.center {
                display: flex;
                align-content: center;

                input {
                  position: relative;
                  top: 0px;
                  margin-right: 5px;
                  margin: 0px 20px;
                }
              }

              .force-start {
                display: flex;
                align-items: center;

                input {
                  position: relative;
                  top: -1px;
                  left: -7px;
                  margin-right: 5px;
                }
              }

              &.text-center {
                text-align: center;
              }
            }

            td {
              .checkbox {
                position: relative;
                top: -1px;
                left: -7px;
                margin-right: 5px;
              }

              .profile-content {
                display: flex;
                align-items: center;
              }

              &.email {
                color: #334d6eb0;
                font-size: 13px;
              }

              .invitation-status {
                padding: 13px 10px;
                width: 130px;
                border-radius: 10px;
                text-align: center;

                &.received {
                  border: 1px solid #1ba5a4;
                  color: #1ba5a4;
                }

                &.sent {
                  border: 1px solid #0884af;
                  color: #0884af;
                }
              }

              .btn-show-cv {
                width: 75px;
                height: 32px;
                background: #f6f6f6;
                border-radius: 5px;
                display: flex;
                align-items: center;
                justify-content: center;
                transition: all 0.2s ease-in-out;

                &:hover {
                  // animate the button
                  transition: all 0.2s ease-in-out;
                  transform: scale(1.05);
                  box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.2);
                }

                img {
                  margin-right: 4px;
                }
              }

              .approve-status {
                padding: 13px 10px;
                width: 110px;
                border-radius: 10px;
                text-align: center;

                span {
                  margin-right: 5px;
                }

                &.approved {
                  border: 1px solid #1ba5a4;
                  color: #1ba5a4;
                }
              }

              .progress-widget {
                width: 100%;
              }

              .table-menu {
                position: relative;
              }

              .center {
                display: flex;
                justify-content: center;
              }

              &:first-child {
                border-top-left-radius: 5px;
                border-bottom-left-radius: 5px;
              }

              &:last-child {
                border-top-right-radius: 5px;
                border-bottom-right-radius: 5px;
              }

              &.text-center {
                text-align: center;
              }

              .btn-invite {
                width: 130px;
                height: 33px;
                background: #0884af;
                border-radius: 10px;
                color: #fff;
              }

              .btn-approve {
                width: 110px;
                height: 33px;
                background: #1ba5a4;
                border-radius: 10px;
                color: #fff;
              }
            }
          }
        }

        .loading-paginated-items {
          height: 50px;
          position: relative;
        }
      }
    }

    .instruct-details {
      width: 260px;
      min-width: 260px;
      max-width: 300px;
      display: flex;
      flex-direction: column;
      height: 100%;
      background: #fff;
      border-radius: 5px;

      .instruct-header {
        font-size: 24px;
        text-align: center;
        padding-top: 20px;
        margin-top: 33px;
        height: 48px;
        margin-bottom: 20px;

        h1 {
          margin: 0px;
          font-size: 25px;
          font-weight: 500;
        }
      }

      .instruct-body {
        height: calc(100% - 48px);
        overflow-y: auto;

        .chart-widget {
          width: 100%;
          border-radius: 5px;
          display: flex;
          justify-content: space-between;
          flex-direction: column;
          margin-bottom: 30px;

          .header {
            padding: 10px 10px;
            color: #333333;
            text-align: center;
          }

          .body {
            display: flex;
            justify-content: center;
            align-items: center;
            height: 200px;
          }

          .footer {
            padding: 10px 10px;
            display: flex;
            justify-content: space-between;

            .label-widget {
              .box-widget {
                display: flex;
                align-items: center;

                .box {
                  height: 15px;
                  width: 15px;
                  background: #1ba5a4;
                  border-radius: 50%;
                  margin-right: 7px;

                  &.active {
                    background: #0884af;
                  }
                }

                .label {
                  font-size: 12px;
                  position: relative;
                  top: 3px;
                }
              }

              .label-info {
                margin-top: 8px;
                text-align: center;
              }
            }
          }
        }
      }
    }
  }

  .form-widget-modal {
    width: 500px;
    min-height: 200px;
    padding: 20px;
  }
}

.search-contact-item {
  padding: 10px 15px;
  display: flex;
  cursor: pointer;
  align-items: center;

  img {
    border-radius: 50%;
    margin-right: 8px;
  }

  &:hover {
    background: rgb(250, 250, 250);
  }
}

.selected-search-contact-item {
  padding: 5px 12px;
  display: flex;
  align-items: center;
  cursor: pointer;
  border: 1px solid #ddd;
  margin-top: 10px;
  border-radius: 15px;
  font-size: 11px;

  img {
    border-radius: 50%;
    margin-right: 8px;
  }

  &:hover {
    background: rgb(250, 250, 250);
  }
}
</style>
